<template>
    <el-dialog
        :show-close="false"
        v-if="show"
        :close-on-click-modal="false"
        v-model="dialogVisible"
        @close="onClose"
        :width="width"
        :title="title"
        top="5vh"
        destroy-on-close
    >
        <div class="ly-content-line">
            <slot></slot>
        </div>
        <div class="ly-content-line ly-align-center">
            <div class="dialog-footer">
                <slot name="button"></slot>
            </div>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: "EditDialog",
    props: {
        title: { type: String, default: "" },
        width: { type: String, default: "600px" },
        show: { type: Boolean, default: false },
    },
    data() {
        return {
            dialogVisible: false,
        };
    },
    created() {
        this.dialogVisible = this.show;
    },
    watch: {
        show(val) {
            this.dialogVisible = val;
        },
    },
    methods: {
        onClose() {
            this.dialogVisible = false;
            this.$emit("close");
        },
    },
};
</script>
